import { IBudgetMarks } from '../../../interfaces/Form';

const getMark = (value:number) => ({ value });

const budgetMarksBuilder = (...options: number[]): IBudgetMarks => {
    switch (options.length) {
    case 0:
        return [];
    case 1:
        return [getMark(options[0])];
    case 2:
        return [getMark(options[0]), getMark(options[1])];
    default: {
        const a = [];
        const [start, step, max, ...rest] = options;
        for (let i = start; i < max; i += step) a.push(getMark(i));

        return [
            ...a,
            ...budgetMarksBuilder(max, ...rest),
        ];
    }
    }
};

export default budgetMarksBuilder;
